import * as React from 'react';
import styled from '../../theme';

const Content = styled.h3`
    padding-left: 20px;
    margin: 10px auto 0 auto;
    font-family: Helvetica;
    font-weight: 400;
    font-size: 0.9em;
    color: ${(props: any) => props.theme.colors.error}; 
    text-align: left;
    width: 100%;
    display: none;
    

    svg {
        width: 14px;
        height: 14px;
        padding-right: 10px;
    }

    &.error {
        display: block;
    }
`

interface IErrorProps {
    content: any | null,
    className?: string,
}

const ErrorMessage = (props: IErrorProps) => {

    if (!props.content || !props.content.length) {
        return null
    } else {
        return <Content
            className={props.className}
        >
            <svg
                aria-hidden="true"
                data-prefix="fas"
                data-icon="exclamation-circle"
                className="svg-inline--fa fa-exclamation-circle fa-w-16"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512">
                <path fill="currentColor"
                    // tslint:disable-next-line:max-line-length
                    d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" />
            </svg>
            {props.content}
        </Content>
    }
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/Inputs/ErrorMessage.tsx